import React from "react";
import AnimatedSection from "@/components/animation/AnimatedSection/AnimatedSection";
import OptImg from "@/components/OptImg";

const HeroSection = () => (
  <section className="flex flex-col">
    {/* Top bar: Logo */}
    <div className="w-full pt-8 px-6 sm:px-12 flex flex-col sm:flex-row justify-between items-start">
      {/* Logo and Title */}
      <div className="flex flex-col sm:flex-row sm:items-start">
        <div className="flex flex-row items-start">
          <span className="text-[70px] sm:text-[150px] leading-none font-bold text-black font-sans tracking-tight select-none">
            TITAN <br></br>Containers
          </span>
        </div>
      </div>
    </div>

    {/* Divider line */}
  </section>
);

const SERVICES = [
  {
    img: "https://titancontainers.id/wp-content/uploads/2022/09/arcticstore-crop-u29717.png", // Example image for ArcticStore
    title: "Buy",
    subtitle:
      "Purchase Affordable and Reliable Portable Refrigerated Storage to Meet Your Requirements",
  },
  {
    img: "https://titancontainers.id/wp-content/uploads/2022/09/ultrafreezer-crop-u30346.png", // Example image for UltraFreezer
    title: "Rent",
    subtitle:
      "Available for Any Range Terms of Rent with Identical Features and Various Size Models",
  },
];

const ServiceSection = () => (
  <section className="bg-white py-16 px-4 md:px-16">
    {/* Top: Title */}
    <div className="max-w-7xl mx-auto mb-14">
      <h1 className="text-[46px] md:text-[56px] font-bold text-[#101616] mb-2">
        Our Services
      </h1>
      <p className="text-[20px] md:text-[22px] text-[#101616] opacity-80 max-w-3xl">
        Discover the most advanced portable cold storage lineup for food,
        pharma, and industrial needs.
      </p>
    </div>
    {/* Product Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-14 gap-y-16 max-w-7xl mx-auto">
      {SERVICES.map((item) => (
        <div
          key={item.title}
          className="flex flex-col bg-[#f8fafb] hover:shadow-xl transition rounded-2xl p-0"
        >
          <div className="w-full aspect-[4/3] overflow-hidden rounded-t-2xl">
            <OptImg
              src={item.img}
              alt={item.title}
              className="w-full h-full object-cover object-center transition hover:scale-105 duration-300"
            />
          </div>
          <div className="flex flex-col p-6">
            <div className="text-[28px] font-bold text-[#101616] mb-1">
              {item.title}
            </div>
            <div className="text-lg font-semibold text-[#101616] mb-2 opacity-80">
              {item.subtitle}
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

const ServicePage = ({ history }) => {
  return (
    <>
      <div>
        <AnimatedSection>
          <HeroSection />
        </AnimatedSection>
        <AnimatedSection>
          <ServiceSection />
        </AnimatedSection>
      </div>
    </>
  );
};

export default ServicePage;
